export default {
    END_USER: "END_USER",

}